import { render, staticRenderFns } from "./ReviewAdd.vue?vue&type=template&id=0fd958e4&"
import script from "./ReviewAdd.vue?vue&type=script&lang=js&"
export * from "./ReviewAdd.vue?vue&type=script&lang=js&"
import style0 from "./ReviewAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports